import React, { createContext, useContext, useState } from 'react';
import PopupNotification from '../components/PopupNotification/PopupNotification';

const NotificationContext = createContext();

// Create a store object to hold the showNotification function
export const store = {
  showNotification: null
};

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    open: false,
    type: null,
    data: null
  });

  const showNotification = (type, data) => {
    setNotification({
      open: true,
      type,
      data
    });
  };

  // Store the showNotification function in the store
  store.showNotification = showNotification;

  const hideNotification = () => {
    setNotification({
      open: false,
      type: null,
      data: null
    });
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <PopupNotification
        open={notification.open}
        onClose={hideNotification}
        type={notification.type}
        data={notification.data}
      />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
}; 